import { ERevampReportReducers } from "@adapters/presenters/action-interfaces/Reports/DashboardSummary";
export class DownloadReportRevamp {
    constructor(downloadAndSendReportUsecases, downloadReportActions) {
        this.downloadAndSendReportUsecases = downloadAndSendReportUsecases;
        this.downloadReportActions = downloadReportActions;
        this.emailList = [];
        this.fromDate = "";
        this.toDate = "";
        this.setdownloadStateData = (downloadStateData) => {
            this.downloadReportActions.setDownloadStateData(downloadStateData, ERevampReportReducers.DownloadNSendEmailReport);
        };
    }
    async emailReport(emailPayload) {
        return new Promise((resolve, reject) => {
            var _a, _b;
            this.emailList = (_b = (_a = emailPayload === null || emailPayload === void 0 ? void 0 : emailPayload.requestBody) === null || _a === void 0 ? void 0 : _a.emailIds) !== null && _b !== void 0 ? _b : [];
            this.downloadAndSendReportUsecases.emailReport.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(false);
                },
            }, emailPayload);
        });
    }
    async downloadPdfExcelReport(downloadPayload) {
        return new Promise((resolve, reject) => {
            this.downloadAndSendReportUsecases.donwloadPdfExcel.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(false);
                },
            }, downloadPayload);
        });
    }
    downloadAndSendReport(email, download) {
        if (email && download)
            return new Promise((resolve, reject) => {
                Promise.all([
                    this.emailReport(email),
                    this.downloadPdfExcelReport(download),
                ])
                    .then((v) => {
                    resolve(v.reduce((prevVal, currVal) => prevVal && currVal, true));
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        if (email) {
            return this.emailReport(email);
        }
        if (download) {
            return this.downloadPdfExcelReport(download);
        }
    }
}
